import { ReactNode } from "react"
import AuthenticatedSidebar from "@/modules/layout/ui/navbar/AuthenticatedSidebar"
import AuthenticatedNavbar from "@/modules/layout/ui/navbar/AuthenticatedNavbar"
import { OrganizationLoader } from "@/modules/layout/ui/components/OrganizationLoader"

interface EmployeeLayoutProps {
  children: ReactNode
}

export default function EmployeeLayout({ children }: EmployeeLayoutProps) {
  return (
    <OrganizationLoader>
      <div className="flex h-screen bg-muted">
        <AuthenticatedSidebar />
        <div className="flex-1 flex flex-col overflow-hidden">
          <AuthenticatedNavbar />
          <main className="flex-1 overflow-x-hidden overflow-y-auto bg-muted">
            {children}
          </main>
        </div>
      </div>
    </OrganizationLoader>
  )
}
